<div
  class="w-12 p-1 transition duration-200 rounded-full cursor-pointer"
  [class]="isOn ? 'bg-green-300' : 'bg-slate-300'"
>
  <div
    [class]="isOn ? 'transform translate-x-full bg-white' : 'bg-gray-400'"
    class="w-5 h-5 transition duration-200 rounded-full shadow-toggleSwitch"
  ></div>
</div>
